 <template>
    <div class="preferences-list">
        <div class="container-fluid">
            <div class="row">
                <div class="col-2 col-lg-1">
                    <div class="preferences-list__numbers">
                        <div v-for="(id, i) in $store.state.favorites" :key="i" class="preferences-list__numbers--number">
                            <span>{{ i + 1 }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-10 col-lg-11">

                    <draggable group="favorites" :list="favorites" @start="drag=true" @end="drag=false" handle=".handle" >
                        <preferences-list-item v-for="(favorite) in $favorites" :key="favorite.id" :house="favorite"></preferences-list-item>
                    </draggable>



                    <router-link class="add-preference d-none d-lg-flex" :to="{ name: 'home' }">
                        <span>Voorkeur toevoegen</span>
                    </router-link>

                </div>
            </div>
            <div class="row">
                <div class="col-12 ">
                    <router-link class="add-preference d-flex d-lg-none" :to="{ name: 'home' }">
                        <span>Voorkeur toevoegen</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PreferencesListItem from '../components/PreferencesListItem.vue'
    import draggable from 'vuedraggable'

    export default {
        components: {
            PreferencesListItem,
            draggable
        },
        data () {
            return {
                favorites: []
            }
        },
        mounted () {
            this.favorites = this.$store.state.favorites
        },
        watch: {
            $favorites (){
                this.favorites = this.$store.state.favorites
            },
            favorites (data) {
                this.favorites = data
                this.$store.commit('setFavorites', data)
            }
        }
    }
</script>
